import { defineMessages } from 'react-intl';

// EWM-1036. Ids stay under estimationDetail.archivedModelBanner.*: the banner started on the
// estimation detail and the translation files are keyed by id, so keeping them spares a rename
// across de.ts and en.ts for a component that only changed directories.
export const archivedModelBannerMessages = defineMessages({
  text: {
    id: 'estimationDetail.archivedModelBanner.text',
    defaultMessage: 'This estimation model has been archived. Existing values remain usable.',
  },
  dismiss: {
    id: 'estimationDetail.archivedModelBanner.dismiss',
    defaultMessage: 'Dismiss',
  },
});
